import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { Grid, Button, Box } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import Loader from "../../loading";
const useStyles = makeStyles((theme) => ({

  card: {
    margin: "auto",
    textAlign: "center",
    background: "linear-gradient(to bottom, #090b24 0%, #102d4d 100%)",
    borderRadius: "0 30px",
    boxShadow: "0 6px 12px -3px rgba(0,0,0,.3)",
    color: "#fff",
    border: "2px solid white"
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "bolder",
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: ".8rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: ".7rem",
    },
  },
  counterValue: {
    position: "relative",
  },

  Header: {

    width: "100%",

  },
  Citysheading: {
    fontFamily: "Bangers,cursive",
    color: "#FF5805",
    textAlign: "center",

  },
  CitesLengt: {
    fontFamily: "Bangers,cursive",
    color: "#FF5805",
    textAlign: "center",
  },
  buycityContainer: {
    marginTop: "2rem"
  }

}));

export default function MiniDrawer() {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch()
  const Aut = useSelector(state => state.AutReducer)
  return (

    <div>

      {Aut.usebuycities && <Grid container >
        <Grid container className={classes.Header}>
          <Grid item lg={6} md={6} sm={12} xs={12}> <Typography variant="h4" className={classes.Citysheading}>User buy CITIES</Typography></Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}> <Typography variant="h4" className={classes.CitesLengt}>Total Cities: {" "}{Aut.usebuycities ? Aut.usebuycities && Aut.usebuycities.length : 0}</Typography></Grid>

        </Grid>
      </Grid>}

      <Grid container spacing={2} className={classes.buycityContainer}>

        {Aut.usebuycities ? Aut.usebuycities && Aut.usebuycities.map((item, i) => (<Grid item lg={3} md={6} sm={12} xs={12} >
          <Paper className={classes.card} key={i}>
            <CardContent >
              <Typography
                className={classes.title}

                gutterBottom
              >
                {item.name}

              </Typography>
              <Typography


                gutterBottom
              >
                Country<span>{" "}  US</span>

              </Typography>
              <Typography
                gutterBottom
              >
                State<span>{" "}  {item.stateCode}</span>
                <br />
                <span className={classes.counterValue}>   <Button variant="outlined" color="secondary" style={{ color: "#F5A623", fontWeight: 900, width: "100%", height: "100%", fontSize: "18px", letterSpacing: "2px", backgroundColor: "#FF5805" }}>
                  <Link to={`/dashboard/city/${item.zip}`} style={{ textDecoration: "none" }}> Details</Link>
                </Button></span>
              </Typography>
            </CardContent>
          </Paper>
        </Grid>)) : <Loader />}


      </Grid>

    </div>
  );
}
